const getters = {
  isUserLogged: state => state.userInfo != null,
  loggedUserInfo: state => state.userInfo,
  isLoggedUserUnilab: state => {
    if (state.userInfo != null)
      if (state.userInfo.role != null) return state.userInfo.role.toLowerCase() == "unilab";
    return false;
  },
  bShowTranslationsId: state => state.showTranslationsId,
  bShowEnglishToolTip: state => state.showEnglishToolTip,
  isAdmin: state => state.isAdmin,
  isUnilab: state => state.isUnilab,
  isDebug: state => state.isDebug,
  cordivariId: state => state.cordivariId,
};

export default getters;
